// src/app/page.tsx
'use client';
import React, { useState, useEffect } from 'react';
import { useAppContext } from 'hooks';
import { useRouter } from 'next/navigation';

const SessionChecker = () => {
  const { jwt } = useAppContext();
  const router = useRouter();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);

    // Check if the user has already been redirected
    const hasRedirected = localStorage.getItem('hasRedirectedToDashboard');

    if (jwt && !hasRedirected) {
      // Redirect to /dashboard and set the flag in localStorage
      router.push('/dashboard');
      localStorage.setItem('hasRedirectedToDashboard', 'true');
    }
  }, [jwt, router]);
  return null
};

export default SessionChecker;



